import { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";

import './Posts.sass'

export default function Posts() {
    // Fetch signed in players league
    const { leagueId } = useParams();

    const [posts, setPosts] = useState([]);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch(`/api/league/${leagueId}/posts`)

                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }

                let data = await res.json();
                console.log(data)
                setPosts(data)

            } catch (err) {
                console.log("Failed to fetch league players.", err)
            }

        }
        fetchData();

    }, [])
    return (
        <div>
            {posts.map(post => {
                return (
                    <div className="post" key={post.id}>
                        <h1 className="post-title">{post.title}</h1>

                        <div className="post-meta-data">{new Date(post.createdAt._seconds * 1000).toLocaleDateString("sv-SE")} {post.createdBy && `-  ${post.createdBy}`}</div>
                        <img className="post-image" src={post.image.url} alt={post.image.fileName} />
                        <div className="post-texts">
                            <p className="post-ingress">{post.ingress}</p>

                            <p className="post-main-text">{post.mainText}</p>
                        </div>

                    </div>
                )
            })}
        </div>

    )
}
